// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__23zUL","filesListContainer":"PosDisputesFiles_filesListContainer__2tnmu","filesButton":"PosDisputesFiles_filesButton__1BLWq"};